import {
  FileInputType,
  FileOnChange,
} from '@/common/components/base/input/fileInput/FileInput.type.ts';
import { useController, useFormContext } from 'react-hook-form';
import { fileSizeValidation } from '@/common/components/base/input/fileInput/fileInput.rules.ts';
import Input from '@/common/components/base/input/base/Input.tsx';
import { css } from 'styled-system/css';
import uploadFileAttachment from '@/common/components/base/input/fileInput/attachments/UploadFileAttachment.tsx';
import RemoveFileModal from '@/modules/Auth/components/modals/RemoveConfirmationFileModal';
import useModal from '@/common/hooks/useModal';

const FileInput = ({
  name,
  disabled,
  defaultValue = '',
  label,
  rules,
  placeholder,
  onChange,
  maxFileSize = 10,
}: FileInputType) => {
  const { control } = useFormContext();
  const controller = useController({
    rules: {
      ...rules,
      validate: (file: File) => {
        if (!file) return true;
        if (file.type !== 'application/pdf') {
          return 'فقط فایل PDF مجاز است';
        }
        return fileSizeValidation(file, maxFileSize);
      },
    },
    control,
    name,
    defaultValue,
  });
  const { field, fieldState } = controller;
  const errorMessage = fieldState.error?.message;
  const {
    closeModal: closeRemoveFileModal,
    openModal: openRemoveFileModal,
    open: isRemoveFileModalOpen,
  } = useModal();

  const fileOnChange: FileOnChange = (file) => {
    field.onChange(file);
    onChange?.(file);
  };

  const openRemoveModal = () => {
    openRemoveFileModal();
  };
  const viewFile = () => {
    const objectUrl = URL.createObjectURL(field.value);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = field.value.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  };
  return (
    <>
      <Input
        inputProps={{
          value: field.value?.name ?? '',
          placeholder,
          disabled,
          readOnly: true,
          ...css.raw({
            color: field.value && !errorMessage ? 'green' : undefined,
            borderColor: field.value && !errorMessage ? 'green' : undefined,
          }),
        }}
        inputRef={field.ref}
        errorMessage={errorMessage}
        label={label}
        endAttachments={uploadFileAttachment({
          onChange: fileOnChange,
          onRemoveFile: openRemoveModal,
          hasUploadedFile: !!field.value,
          onViewFile: viewFile,
          disabled: !!disabled,
        })}
      />
      <RemoveFileModal
        open={isRemoveFileModalOpen}
        closeModal={closeRemoveFileModal}
        onModalRemoveFile={() => field.onChange(null)}
      />
    </>
  );
};
export default FileInput;
